import { openModal } from './modal';

const galleryJsClass = 'js-gallery';
const buttonJsClass = galleryJsClass + '-button';
const linkJsClass = galleryJsClass + '-link';

const galleryElements = document.querySelectorAll('.' + galleryJsClass) as NodeListOf<HTMLElement>;

galleryElements.forEach((galleryElement) => {
    const linkElement = galleryElement.querySelector('.' + linkJsClass) as HTMLElement;
    const title = galleryElement.dataset.title ? galleryElement.dataset.title : 'Galerie photo';
    const url = galleryElement.dataset.url;

    if (!linkElement || !url) {
        return;
    }

    // Add event listener on link to open modal
    linkElement.addEventListener('click', () => {
        openModal(linkElement, url, title, 0);
    });

    // Get all buttons
    const buttonElements = galleryElement.querySelectorAll('.' + buttonJsClass) as NodeListOf<HTMLButtonElement>;

    buttonElements.forEach((buttonElement, index) => {
        // Add event listener on button to open modal
        buttonElement.addEventListener('click', () => {
            openModal(buttonElement, url, title, index);
        });
    });
});